export const flagshipProjects = [
  {
    id: "vintran",
    name: "Vintran — Fintech Payments & Inventory Platform",
    stack: "C#/.NET, gRPC, Redis",
    desc: "Startup platform of ~14 microservices (identity, gateway, payments, inventory, benefits) over gRPC/Protobuf with REST at the gateway, built within a 15-person product team. Co-developed the backend alongside the lead engineer — Redis-backed idempotent payment sessions, JWT with tenant/admin claim separation, double-entry ledger flows — and led pre-QA validation and hardening across CQRS handlers, multi-tenant isolation, auth boundaries, idempotency, and ledger correctness.",
    tags: ["C#/.NET", "gRPC/Protobuf", "Redis", "Microservices"],
    metrics: [
      { value: "14", label: "Microservices" },
      { value: "15", label: "Person product team" },
      { value: "gRPC", label: "Protobuf-based gateway" },
    ],
  },
  {
    id: "stayops",
    name: "StayOps ERP — Multi-Tenant Hotel Operations SaaS",
    stack: "Node.js, TypeScript, Express, Prisma, PostgreSQL, Redis, R2",
    desc: "Hotel-operations platform (front desk, POS, housekeeping, accounting/payroll) spanning 50+ feature domains with strict tenant isolation. Double-entry accounting engine enforcing debits-equal-credits in code with Decimal arithmetic; immutable guest ledger with atomic materialized-balance updates in the same transaction; three-layer JWT revocation; tiered rate limiting. Ran a self-directed security audit that found and fixed a cross-tenant IDOR before release.",
    tags: ["Node.js", "Prisma", "PostgreSQL", "Multi-Tenant"],
    metrics: [
      { value: "50+", label: "Feature domains" },
      { value: "0", label: "Debit/credit drift, enforced in code" },
      { value: "IDOR", label: "Found & fixed pre-release" },
    ],
  },
  {
    id: "yourateme",
    name: "YouRateMe — Ratings & Discovery Platform",
    stack: "NestJS, MongoDB, Redis, BullMQ, Socket.IO",
    desc: "Single API — 221 endpoints across 41 modules — serving web, mobile (Expo/React Native), and admin clients. Async reputation engine recomputing trust-weighted scores via a single $facet aggregation, with BullMQ job-ID coalescing collapsing rating bursts into one recompute across distributed instances; transactional-outbox notifications; dual-RSA-keypair RS256 auth with Redis-revocable sessions; 25+ purpose-built indexes.",
    tags: ["NestJS", "MongoDB", "BullMQ", "Socket.IO"],
    metrics: [
      { value: "221", label: "Endpoints" },
      { value: "41", label: "Modules" },
      { value: "25+", label: "Purpose-built indexes" },
    ],
  },
  {
    id: "healthcare-workforce",
    name: "Healthcare Workforce Platform (UK/NHS Domain)",
    stack: "Node.js, TypeScript, MongoDB",
    desc: "Multi-tenant staffing platform connecting healthcare professionals to shifts across multiple NHS trusts. Multi-organization login via a short-lived, single-use trust-selection token before the tenant-scoped JWT; per-membership RBAC (7 roles); adapter-pattern compliance verification (NMC/GMC/HCPC/DBS); blockchain-anchored audit trail with non-blocking capped retries; idempotent recurring shift generation over a rolling 28-day horizon; all money in integer pence.",
    tags: ["Node.js", "MongoDB", "RBAC", "Compliance"],
    metrics: [
      { value: "7", label: "RBAC roles per membership" },
      { value: "28-day", label: "Rolling shift horizon" },
      { value: "~14", label: "Analytics pipelines" },
    ],
  },
  {
    id: "areafada",
    name: "AreaFada OS — Creator-Economy SaaS",
    stack: "PostgreSQL, Render, Vercel",
    desc: "Took an AI-scaffolded prototype to production for a Nigerian entertainment icon's platform — migrated infrastructure to Render/Vercel with graceful shutdown and tuned pooling; authored a schema-integrity migration adding foreign keys and indexes across an 86-table PostgreSQL schema (67 had none); found and fixed SSRF, stored XSS, an OAuth-credential-leaking endpoint, and a non-constant-time admin auth check; wrote the platform's first payment-webhook tests; traced a systemic URL bug silently 404ing nine production features.",
    tags: ["PostgreSQL", "Security Audit", "Paystack/Flutterwave"],
    metrics: [
      { value: "86", label: "Table schema hardened" },
      { value: "4", label: "Security vulnerabilities fixed" },
      { value: "9", label: "Silently-broken features fixed" },
    ],
  },
  {
    id: "safiox",
    name: "Safiox — Emergency Response & Community Safety Platform",
    stack: "Node.js, MongoDB, Socket.IO, React Native (Expo)",
    desc: "Full-stack development on a real-time platform connecting people in danger with nearby responders, official services, and personal contacts: SOS alerts with live GPS; geospatial responder discovery (MongoDB 2dsphere/$nearSphere); simultaneous push + Socket.IO + in-app broadcast with per-responder status tracking; per-alert live chat with location streaming every 15s; verified-organization flows for police, hospital, fire, and ambulance.",
    tags: ["MongoDB Geospatial", "Socket.IO", "React Native"],
    metrics: [
      { value: "20+", label: "API modules" },
      { value: "40+", label: "React Native screens" },
      { value: "15s", label: "Live location streaming interval" },
    ],
  },
];

const Project = [
  {
  "id": 7,
  "name": "AFRIMA: ALL AFRICA MUSIC AWARDS",
  "link": "https://afrima.org",
  "image": "../../Images/afrima_org.png",
  "desc": "Contributed as part of the development team behind AFRIMA’s global digital presence. Supported the build and enhancement of the platform’s architecture and user experience, ensuring scalability for high-traffic events. Collaborated on visual and functional modules that power artist showcases, news updates, and award engagement across Africa’s music industry.",
  "language": "React, Tailwind CSS, Node.js, Express, MongoDB"
  },
  {
    id: 1,
    name: "HALLOS : Creators Marketplace & Livestreaming Platform",
    link: "https://www.hallos.net/",
    image: "../../Images/aahbibi.png",
    desc: "A scalable EdTech and creator platform designed to power video-on-demand, live classes, and gamified learning experiences. I led backend development using Node.js, Express, PostgreSQL, and Redis, building secure role-based APIs, live class infrastructure, wallet and payment systems, and quiz-based engagement logic. The platform supports real-time sessions, subscriptions, and creator monetization with production-ready performance and reliability.",
    language: "",
  },
  {
  "id": 8,
  "name": "DFX Limited : Multi-Module Business Platform",
  "link": "https://www.dfxlimited.com",
  "image": "../../Images/dfx.png",
  "desc": "A modular multi-service digital platform built to support IT training enrollment, gadget e-commerce, and agency lead management under a unified system. I led backend development using Node.js, Express, and MongoDB, designing secure role-based APIs, payment integrations, file uploads for course materials, and admin dashboards. The platform emphasizes scalability, clean architecture, and reliable workflows for real-world business operations.",
  "language": "React, Tailwind CSS, Node.js, Express, MongoDB"
  },
     {
  "id": 6,
  "name": "Yupacgo : AI-Powered Investment Platform",
  "link": "https://www.yupacgo.com/",
  "image": "../../Images/yupacgo.png",
  "desc": "Yupacgo, a backend-driven investor recommendation platform, built to deliver personalized stock insights through secure onboarding, rule-based intelligence, live market data aggregation, and virtual portfolios—showcasing my ability to design scalable, data-intensive financial systems end-to-end.",
  "language": "Node.js, React, Tailwind CSS, MongoDB, Express, Redis"
  },
  {
  "id": 7,
  "name": "AFRIMA: Adjudication Portal",
  "link": "https://www.afrimajury.com",
  "image": "../../Images/afrima_jury.png",
  "desc": "A Full-Stack Adjudication system powering Africa’s premier music awards, built to streamline jury evaluations across regional and continental categories. I led backend development with Node.js, Express, and MongoDB, designing secure APIs, dynamic scoring and ranking logic, and automated PDF/Excel reporting. The platform enables transparent judging with role-based dashboards and activity logging for audit-ready results.",
  "language": "React, Tailwind CSS, Node.js, Express, MongoDB"
  },
  {
  "id": 5,
  "name": "Gulf Of Guinea Midstream",
  "link": "https://www.ggmid.com/",
  "image": "../../Images/ggmid.png",
  "desc": "Digital showcase for Gulf of Guinea Midstream Limited, a strategically driven mid‑stream energy company in Nigeria—highlighting its core infrastructure investments, industrial gas park development (Anoh CNG Park), and integrated approach to sustainable gas monetization and regional energy logistics.",
  "language": "React, Tailwind CSS"
  },
  {
  "id": 4,
  "name": "Anoh Gas Park",
  "link": "https://www.acngpark.com/",
  "image": "../../Images/acng.png",
  "desc": "Official platform for the Anoh CNG Industrial Park initiative — a catalytic project designed to revolutionize Nigeria’s gas-based industrialization by enabling decentralized energy access, manufacturing localization, and large-scale investment in compressed natural gas infrastructure.",
  "language": "React, Tailwind CSS"
  },
  {
  "id": 7,
  "name": "FinCalc: Expense Tracker",
  "link": "https://fin-calc-beta.vercel.app/login",
  "image": "../../Images/fincalc.png",
  "desc": "FinCalc, a Full-Stack SaaS Finance Management Platform, designed to empower individuals with secure authentication, intuitive expense tracking, real-time data visualization, and seamless Excel exports—already trusted by 1000+ users as a testament to my end-to-end engineering expertise.",
  "language": "React, Tailwind CSS, Node.js, Express, MongoDB"
  },
  {
    id: 3,
    name: "Gulf Of Guinea Oil Exploration",
    link: "https://ggoex.com/",
    image: "../../Images/ggoex.png",
    desc: "Strategic digital presence for Gulf of Guinea Oil Exploration Limited, built to communicate its role in unlocking Nigeria’s offshore gas potential through innovative infrastructure, strategic partnerships, and ESG-driven investment platforms across West Africa’s energy frontier.",
    language: "React, Tailwind CSS",
  },
  {
    id: 1,
    name: "Pinkyshelbybeauty Fashion Store",
    link: "https://pinkyshelbybeauty.com/",
    image: "../../Images/pinky.png",
    desc: "Built full e-commerce stack with JWT auth, multi-role access, real-time stock, paystack integration; improved checkout completion by ~20%.",
    language: "",
  },
  {
    id: 1,
    name: "SoleComfortShoes (US-based Retail Brand)",
    link: "https://solecomfort.shoes/",
    image: "../../Images/solecomfort.png",
    desc: "Developed a responsive e-commerce storefront for a U.S. footwear company; implemented secure checkout, optimized product discovery, and performance tuning to support cross-border customers.",
    language: "",
  },
  {
    id: 1,
    name: "Lana Renovations",
    link: "https://ahmed-web-project.vercel.app/index.html",
    image: "../../Images/Lana-Renovations.png",
    desc: "End-to-end digital solution for a UK-based home renovation brand, crafted to elevate local market credibility through a fully responsive website with SEO-optimized structure, accessible design, and mobile-first performance to establish a compelling and trustworthy online presence.",
    language: "",
  },
];

export default Project;